import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../shared/store';
import { useHttpClient } from '../../../shared/http-client';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { CheckIcon, ExclamationCircleIcon, XIcon } from '@heroicons/react/outline';
import { Exclamacion } from '../../../../assets/icons/Exclamacion';
import { ExclamacionYellow } from '../../../../assets/icons/ExclamacionYellow';
import { ConductoresForm } from './conductores-form';
import { AsignacionesTab } from './tabs/asignaciones-tab';
import { AccidentesTab } from './tabs/accidentes-tab';
import { MultasTab } from './tabs/multas-tab';
import { GeneralTab } from './tabs/general-tab';


export const ConductoresEdit = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { api, state } = useHttpClient();
    const { id } = useParams();
    const { get, set } = useStore();
    const [data, setData] = useState<any | null>(null);
    const [isTab, setIsTab] = useState(false);
    const [tabIndexMaster, setTabIndexMaster] = useState(+get('driver-tab-index') || 0);

    useEffect(() => {
        if (id) {
            api(`/fleet/drivers/${id}/`, 'GET');
        }
    }, [id]);



    const handleChangeValues = () => {
        setIsTab(true);
        api(`/fleet/drivers/${id}/`, 'GET');
    };

    useEffect(() => {
        if (state.data) {
            if (state.path.includes('drivers')) {
                setData(state.data);
                /* if (!isTab) {
                    setTabIndexMaster(0);
                } */
            }
        }

        if (state.error) {
            toast.error(state.error.detail);
        }
    }, [state]);

    return (
        <div className='py-4 px-8'>
            <div
                className="pb-4 cursor-pointer"
                onClick={() => {
                    navigate(-1);
                    setTabIndexMaster(0);
                    set('driver-tab-index', 0);
                }}
            >
                <span className='text-black pt-[5px]'>{'< '}</span>
                <span className='text-black text-[12px]'>{t('common.button.back')}</span>
            </div>
            <div className='flex'>
                <div className="text-2xl  text-gray-900 pb-4 pr-4">
                    {t('common.label.conductor')}
                </div>
                <span className='pl-[2px] mt-[6px]'>{data?.status === "OK" ? (
                    <CheckIcon
                        className={
                            'h-5 w-5 p-1 text-white rounded-full bg-green-400'
                        }
                    />
                ) : data?.status === "WARNING" ? (
                    <ExclamacionYellow />
                ) : (
                    <Exclamacion />
                )}</span>
            </div>

            <Tabs
                selectedIndex={tabIndexMaster}
                onSelect={(index) => {
                    setTabIndexMaster(index);
                    set('driver-tab-index', index);
                }}>
                <TabList>
                    <Tab style={{ fontWeight: tabIndexMaster === 0 ? 'bold' : 'normal' }} >
                        <div className='flex'>
                            {t('common.label.general')}{/* <ExclamationCircleIcon className="h-6 w-6 text-red-600 rounded-full ml-2" /> */}
                        </div>
                    </Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 1 ? 'bold' : 'normal'
                    }} >{t('common.label.asignaciones')}</Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 2 ? 'bold' : 'normal'
                    }} >{t('common.label.accidentes')}</Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 3 ? 'bold' : 'normal'
                    }} ><div className='flex'>
                            {t('common.label.multas')}<span className='pl-[4px]'>{data?.sanction_status === "OK" ? (
                                <CheckIcon
                                    className={
                                        'h-5 w-5 p-1 text-white rounded-full bg-green-400'
                                    }
                                />
                            ) : data?.sanction_status === "WARNING" ? (
                                <ExclamacionYellow />
                            ) : (
                                <Exclamacion />
                            )}</span>
                        </div></Tab>
                </TabList>

                <TabPanel>
                    <GeneralTab item={data} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <AsignacionesTab item={data} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <AccidentesTab item={data} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <MultasTab item={data} onAction={handleChangeValues} />
                </TabPanel>
            </Tabs>

        </div>
    );
};